import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Api } from '@shared/constants/api';
import { Odt2Platform } from '@shared/constants/odt';
import { RestBuilder } from './helpers/rest.builder';

@Injectable({ providedIn: 'root' })
export class OdtService {
  private restBuilder: RestBuilder;

  constructor() {
    this.restBuilder = new RestBuilder();
  }

  /**
   * Returns the API URL for the ODT download endpoint.
   * The server returns the .dmg file directly to the client.
   */
  public getDownloadUrl(): string {
    // /odt/download
    return this.restBuilder.create().odt().download().getApiUrl();
  }

  /**
   * Returns the API URL for the ODT v2 download endpoint for the given platform.
   * The server returns the installer for that platform directly to the client.
   */
  public getV2DownloadUrl(platform: Odt2Platform): string {
    // /odt/download/v2?platform=...
    return this.restBuilder.create().odt().download().v2().query(new HttpParams().set(Api.platform, platform)).getApiUrl();
  }
}
